import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import { unref as _unref, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, isRef as _isRef, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-933ac146"), n = n(), _popScopeId(), n;
};

var _hoisted_1 = {
  class: "icon-body"
};

var _hoisted_2 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("i", {
    class: "el-icon-search el-input__icon"
  }, null, -1);
});

var _hoisted_3 = {
  class: "icon-list"
};
var _hoisted_4 = ["onClick"];
import { ref } from '@vue/reactivity';
import { onMounted } from '@vue/runtime-core';
import icons from './requireIcons';
import svgIcon from '@/components/SvgIcons';
export default {
  __name: 'index',
  emits: ['selected'],
  setup: function setup(__props, _ref) {
    var expose = _ref.expose,
        emit = _ref.emit;
    var iconName = ref('');
    var iconList = ref(icons);

    function filterIcons() {
      iconList.value = icons;

      if (iconName.value) {
        iconList.value = icons.filter(function (item) {
          return item.indexOf(iconName.value) !== -1;
        });
      }
    }

    function selectedIcon(name) {
      emit('selected', name);
      document.body.click();
    }

    function reset() {
      iconName.value = '';
      iconList.value = icons;
    }

    expose({
      reset: reset
    });
    return function (_ctx, _cache) {
      var _component_el_input = _resolveComponent("el-input");

      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_input, {
        modelValue: _unref(iconName),
        "onUpdate:modelValue": _cache[0] || (_cache[0] = function ($event) {
          return _isRef(iconName) ? iconName.value = $event : null;
        }),
        style: {
          "position": "relative"
        },
        clearable: "",
        placeholder: "请输入图标名称",
        onClear: filterIcons,
        onInput: filterIcons
      }, {
        suffix: _withCtx(function () {
          return [_hoisted_2];
        }),
        _: 1
      }, 8, ["modelValue"]), _createElementVNode("div", _hoisted_3, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(iconList), function (item, index) {
        return _openBlock(), _createElementBlock("div", {
          key: index,
          onClick: function onClick($event) {
            return selectedIcon(item);
          }
        }, [_createVNode(_unref(svgIcon), {
          "icon-class": item,
          style: {
            "height": "30px",
            "width": "16px"
          }
        }, null, 8, ["icon-class"]), _createElementVNode("span", null, _toDisplayString(item), 1)], 8, _hoisted_4);
      }), 128))])]);
    };
  }
};